import { render } from "./UserDetailPage.vue?vue&type=template&id=0757321a&ts=true"
import script from "./UserDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user/UserDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0757321a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0757321a', __exports__)) {
    api.reload('0757321a', __exports__)
  }
  
  module.hot.accept("./UserDetailPage.vue?vue&type=template&id=0757321a&ts=true", () => {
    api.rerender('0757321a', render)
  })

}


export default __exports__